import type { UserType } from 'core/types'

const getPage = (pathname: string) => {
  const lastSlash = pathname.lastIndexOf('/')
  const page = pathname.substring(lastSlash + 1)
  return page
    .split('-')
    .join(' ')
    .replace(/\b\w/g, (l) => l.toUpperCase())
}

type GetPageTitleParams = {
  pathname: string
  brandName: string
  userType: UserType
}

export const getPageTitle = ({ pathname, brandName, userType }: GetPageTitleParams): string => {
  const brandLabel = brandName ? `${brandName} -` : ''
  const isLogin = pathname.includes('login')
  const isLoanApp = pathname.includes('loans') || pathname.includes('account-settings')
  const isCRM = pathname.includes('crm')
  const isBorrower = userType === 'borrower'
  const isAgent = userType === 'agent'

  if (isLogin) {
    const formType =
      isBorrower ? ' Account'
      : isAgent ? ' Agent'
      : ''
    return `${brandLabel}${formType} Login`
  }

  if (isCRM) {
    const isManagerDashboard = pathname.includes('manager-dashboard')
    const isBorrowerView = pathname.includes('borrowers')
    const isCompanyView = pathname.includes('companies')

    if (isManagerDashboard) {
      return `${brandLabel} Agent Portal - Manager Dashboard`
    }
    if (isBorrowerView) {
      return `${brandLabel} Agent Portal - Borrower CRM`
    }
    if (isCompanyView) {
      return `${brandLabel} Agent Portal - Company CRM`
    }
    return `${brandLabel} Agent Portal`
  }

  if (isLoanApp) {
    const page = getPage(pathname)
    return `${brandLabel} ${isAgent ? 'Viewing ' : ''}Customer Portal - ${page}`
  }

  return brandName || ''
}
